<div fxLayout="column" fxFlex fusePerfectScrollbar class="quick-panel-list-wrapper">
  <mat-toolbar color="primary">
    <mat-toolbar-row>
      <span>TORCH Settings</span>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-list>
    <h3 matSubheader>
      <span>Quick Toggles</span>
    </h3>

    <mat-list-item>
      <mat-slide-toggle fxFlex class="mat-primary" [(ngModel)]="showStocks" aria-label="Stock Price Toggle"
                        labelPosition="before" (change)="updateShowStocks($event)">
        <h3>Toolbar Stock Price</h3>
      </mat-slide-toggle>
    </mat-list-item>
    <mat-list-item>
      <mat-slide-toggle fxFlex class="mat-primary" [(ngModel)]="showPartHealthHomeCharts"
                        aria-label="Part Health Home Charts Toggle"
                        labelPosition="before" (change)="updateShowPartHealthHomeCharts($event)">
        <h3>Part Health Home Charts</h3>
      </mat-slide-toggle>
    </mat-list-item>
    <mat-list-item>
      <mat-slide-toggle fxFlex class="mat-primary" [(ngModel)]="notifyUpdates"
                        aria-label="Notify on TORCH Updates"
                        labelPosition="before" (change)="updateNotifyUpdates($event)">
        <h3>Notify on TORCH Updates</h3>
      </mat-slide-toggle>
    </mat-list-item>
  </mat-list>

  <mat-list class="debug-list" *ngxPermissionsOnly="['torchAdmin', 'torchGlobalAdmin']">
    <h3 matSubheader>
      <span>TORCH Debugging</span>
      <mat-divider></mat-divider>
    </h3>

    <mat-list-item class="warn-item" *ngIf="isDevelopment">
      <div class="warn-toggle">
        <mat-icon>warning</mat-icon>
        <span>Toggling this will reload the page</span>
      </div>

      <mat-slide-toggle fxFlex class="mat-primary small-toggle" [(ngModel)]="useRemoteFileSocketBackend"
                        aria-label="File Socket Remote Backend Toggle"
                        labelPosition="before" (change)="updateUseRemoteFileSocketBackend($event)">
        <h3>Use Remote Files Socket Backend</h3>
      </mat-slide-toggle>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item class="warn-item">
      <div class="warn-toggle">
        <mat-icon>warning</mat-icon>
        <span>Toggling this will reload the page</span>
      </div>

      <mat-slide-toggle fxFlex class="mat-primary small-toggle" [(ngModel)]="debugWebsockets"
                        aria-label="Debug Websockets Toggle"
                        labelPosition="before" (change)="updateDebugWebsockets($event)">
        <h3>Debug Websockets</h3>
      </mat-slide-toggle>

    </mat-list-item>

    <mat-list-item class="info-item">
      <div class="info ">
        <span>In PWA?</span>
        <span>
          <mat-icon *ngIf="isPWA" class="green-icon">done</mat-icon>
          <mat-icon *ngIf="!isPWA" class="red-icon">close</mat-icon>
        </span>
      </div>

    </mat-list-item>

    <h3 matSubheader>
      <span>Errors/Logging</span>
    </h3>

    <mat-list-item class="button-item">
      <button mat-stroked-button (click)="throwError()">Throw Error</button>
    </mat-list-item>

    <mat-list-item class="button-item">
      <button mat-stroked-button (click)="throwNetError()">Throw HTTP Error</button>
    </mat-list-item>


    <mat-list-item class="button-item">
      <button mat-stroked-button (click)="printLogMessages()">Print Log Messages</button>
      <mat-divider></mat-divider>
    </mat-list-item>

    <h3 matSubheader>
      <span>MSAL Tokens</span>
    </h3>

    <mat-list-item class="copy-item">
      <div class="token-box">
        <div class="title-box">
          <h3>Graph Token</h3>
          <button mat-icon-button (click)="copyGraphTokenToClipboard()">
            <mat-icon>assignment</mat-icon>
          </button>
        </div>
        <textarea onclick="this.focus();this.select()" readonly>{{graphToken|async}}</textarea>
      </div>

      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item class="copy-item">
      <div class="token-box">
        <div class="title-box">
          <h3>TORCH Token</h3>
          <button mat-icon-button (click)="copyTorchTokenToClipboard()">
            <mat-icon>assignment</mat-icon>
          </button>
        </div>
        <textarea onclick="this.focus();this.select()" readonly>{{torchToken|async}}</textarea>
      </div>
    </mat-list-item>
  </mat-list>

</div>
